export const PATH_CAR_LIST = 'reservation';
export const PATH_CAR_DETAIL = 'reservation/:id';
export const PATH_CONTACT = 'contact';
